import React from 'react';
import FavoriteListItem from 'flow/components/contact-card/contact-fields/FavoriteListItem';
import PriorityCallsListItem from 'flow/components/contact-card/contact-fields/PriorityCallsListItem';
import SharedContactListItem from 'flow/components/contact-card/contact-fields/SharedContactListItem';
import { useAppSelector } from 'flow/hooks/useRedux';
import { selectOwnExtensionKey } from 'flow/selectors/ExtensionSelectors';
import { Contact, ContactFull } from 'flow/types/Contact';
import { ExtensionKey } from 'flow/types/EntityKeys';
import { TypedMap } from 'flow/types/TypedMap';
import { ContactType } from 'flow/utils/extension-utils';

interface Props {
    contact: TypedMap<Contact> | TypedMap<ContactFull>;
    extensionKey?: ExtensionKey;
    /** Passed to every row; see `ContactSettingRow`. */
    rowClassName?: string;
}

const ContactSettingsItems = ({
    contact,
    extensionKey,
    rowClassName,
}: Props) => {
    const ownExtensionKey = useAppSelector(selectOwnExtensionKey);
    const contactType = contact.get('type');
    const showSharedSwitch =
        contactType === ContactType.shared.key ||
        contactType === ContactType.personal.key;

    return (
        <>
            {showSharedSwitch && (
                <SharedContactListItem
                    contactKey={contact.get('key')}
                    shared={contactType === ContactType.shared.key}
                    className={rowClassName}
                />
            )}
            <FavoriteListItem
                favoriteTypeKey={extensionKey || contact.get('key')}
                // A contact favourite can be created from this contact before
                // the store holds it; an extension favourite always has its
                // extension in the store.
                fallbackData={extensionKey ? undefined : contact}
                className={rowClassName}
            />
            {ownExtensionKey !== extensionKey && (
                <PriorityCallsListItem
                    contact={contact}
                    className={rowClassName}
                />
            )}
        </>
    );
};

export default ContactSettingsItems;
